import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LANGUAGES } from '../Constants/Languages.constants';

const resources = LANGUAGES.reduce(
  (acc, item) => ({ ...acc, [item]: { translations: require(`../Assets/Locale/${item}.json`) } }),
  {},
);

i18n.use(initReactI18next).init({
  resources,
  ns: ['translations'],
  fallbackLng: (code) => {
    if (code === 'keys') return '';
    return 'en';
  },
  lng: 'en',
  debug: false,
  defaultNS: 'translations',
  keySeparator: false,
  react: {
    useSuspense: true,
  },
  missingKeyHandler: (_lng, _ns, key) => {
    // eslint-disable-next-line no-console
    console.warn(`Missing Key: ${key}`);
  },
  saveMissing: true,
});

export default i18n;
